/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuImage } from '@neutron/react';

/**
 * Style Imports
 */
import {
  CardContainer,
  CardHeader,
  CardHeaderContainer,
  CardContent,
  CardContentBold,
  CardContentContainer,
  CardContentMetaDataContainer,
  ChevronRightIcon,
  CoachingOppLabel,
  CoachingOppsContainer
} from './PastRoundCard.styles';

/**
 * Static File Imports
 */
import competentIcon from '../../../../../assets/images/competent_icon.png';
import developmentIcon from '../../../../../assets/images/development_icon.png';
import expertIcon from '../../../../../assets/images/expert_icon.png';

/**
 * Constant Imports
 */
import validationCompetencies from '../../../../../constants/validValidationCompetencies.json';

interface PastRoundCardProps {
  dateTime: string;
  roundId: string;
  name: string;
  userId: string;
  facility: string;
  room: string;
  template?: string;
  unitId: string;
  tag?: string[];
  coachingOpportunities?: string[];
}

const PastRoundCard: FC<PastRoundCardProps> = ({
  dateTime,
  roundId,
  name,
  userId,
  facility,
  room,
  template,
  unitId,
  tag,
  coachingOpportunities
}) => {
  const hasValidationCompetency =
    Array.isArray(tag) && tag.find(t => validationCompetencies.includes(t));

  const competencyIcon = hasValidationCompetency
    ? tag?.some(t => t.includes('_E'))
      ? expertIcon
      : tag?.some(t => t.includes('_C'))
      ? competentIcon
      : tag?.some(t => t.includes('_D'))
      ? developmentIcon
      : ''
    : '';

  const competencyText = hasValidationCompetency
    ? tag?.some(t => t.includes('_E'))
      ? ' - Expert'
      : tag?.some(t => t.includes('_C'))
      ? ' - Competent'
      : tag?.some(t => t.includes('_D'))
      ? ' - Developing'
      : ''
    : '';

  return (
    <CardContainer id={`Round-Card-${roundId}`} className="ms-2 me-3">
      {hasValidationCompetency && (
        <CardHeaderContainer>
          <NeuImage width="24" alt="competency logo" src={competencyIcon} />
        </CardHeaderContainer>
      )}
      <CardContentContainer>
        <CardContentMetaDataContainer>
          <CardHeader>{dateTime}</CardHeader>
          <CardContent>{`${name} ${userId}`}</CardContent>
          <CardContent>{facility}</CardContent>
          <CardContent>{`${room || ''} ${unitId || ''}`}</CardContent>
          {template && (
            <CardContentBold>
              {template}
              {hasValidationCompetency && competencyText}
            </CardContentBold>
          )}
        </CardContentMetaDataContainer>
        {coachingOpportunities && (
          <CoachingOppsContainer>
            {coachingOpportunities.map(opportunity => (
              <CoachingOppLabel key={opportunity}>
                {opportunity.replace(/\b\w/g, char => char.toUpperCase())}
              </CoachingOppLabel>
            ))}
          </CoachingOppsContainer>
        )}
      </CardContentContainer>
      <ChevronRightIcon>chevron_right</ChevronRightIcon>
    </CardContainer>
  );
};

export default PastRoundCard;
